import {
  BasketProvider,
  CreateOrderPayload,
  CreateOrderResponse,
} from "../basketProvider/BasketProvider";
import { setCookie } from "../../../api/utils/utils";

export type {
  CreateOrderPayload,
  CreateOrderResponse,
  OrderProduct,
} from "../basketProvider/BasketProvider";

export default class BasketServices {
  static async AllBasket() {
    const res = await BasketProvider.getAllBasket();
    return res.data;
  }
  static async AddBasket(payload: {
    product_id: number;
    quantity: number;
    variant_id?: number;
  }) {
    const res = await BasketProvider.postAddBasket(payload);
    // If guest_token is returned, save it to cookie
    if (res.data?.guest_token) {
      setCookie("x-guest-token", res.data.guest_token, 30); // 30 days expiry
    }
    return res.data;
  }
  static async CreateOrder(
    payload: CreateOrderPayload
  ): Promise<CreateOrderResponse> {
    const res = await BasketProvider.createOrder(payload);
    return res.data;
  }
  static async UpdateBasket(payload: {
    product_id: number;
    quantity: number;
    variant_id?: number;
  }) {
    const res = await BasketProvider.putBasket(payload);
    return res.data;
  }
  static async DeleteBasket(productId: number, variantId?: number) {
    const res = await BasketProvider.deleteBasket(productId, variantId);
    return res.data;
  }
  static async ClearBasket() {
    const res = await BasketProvider.clearBasket();
    return res.data;
  }
  static async TotalBasket() {
    const res = await BasketProvider.getTotalBasket();
    return res.data;
  }
  static async AllFilials() {
    const res = await BasketProvider.getFilials();
    return res;
  }

  static async QuickOrder(payload: {
    product_id: number;
    name: string;
    phone: string;
  }) {
    const res = await BasketProvider.postQuickOrder(payload);
    return res.data;
  }
}
